<template lang="pug">
.ag-custom-header(:class='params.column.colDef.className')
  a.header-label(v-if='params.displayName !== "_"'
    :title='params.displayName'
    :class='{ disabled, nowrap: params.column.colDef.nowrap === false }'
    href='#'
    @click.prevent='showMenu($event)'
  ) {{params.displayName}}
    span.badge {{appliedFilters}}
  i.fas.ag-header-sort-icon(
    v-if='params.enableSorting'
    :class='sortState'
    v-tooltip.bottom='tooltip(sortState)'
    @click='sortColumn'
  )
    i.fas.fa-caret-up(:class='params.column.sort')
    br
    i.fas.fa-caret-down(:class='params.column.sort')
  i.fas.fa-thumbtack.pull-right.ag-pin-column-icon(v-if='!params.column.colDef.action && params.api.gridOptionsWrapper.gridOptions.pinning'
    @click='pinColumn',
    :class='{ "active": params.column.pinned, "last": isLast }'
  )
  checkbox-proxy(v-if='headerCheckbox' :header-checkbox='headerCheckbox' :context='params.context')
</template>

<script>

const SORT_ASCENDING = 'fa-sort-up'
const SORT_DESCENDING = 'fa-sort-down'
const SORT_UNSORTED = 'fa-sort'

import Vue from 'vue'
import checkboxProxy from './cells/checkboxProxy'

export default Vue.extend({
  components: {
    checkboxProxy
  },

  created() {
    const dragRows = this.params.context.dragRows
    const headerCheckbox = dragRows ? 'action-drag' : 0
    let cell
    if (this.params.column.colDef.action === 'checkbox') {
      this.$nextTick(() => {
        cell = this.params.api.headerRenderer
          .childContainers[1]
          .headerRowComps[0]
          .headerComps[headerCheckbox]
        this.headerCheckbox = cell && cell.eHtmlElement
      })
    }
  },

  data() {
    return {
      //
      headerCheckbox: null
    }
  },

  computed: {
    sortState() {
      return this.params.column.sort === 'asc' ? 'fa-sort-up'
             : this.params.column.sort === 'desc' ? 'fa-sort-down'
             : 'fa-sort'
    },

    isLast() {
      return this.params.column.left === this.params.columnApi._columnController.bodyWidth - this.params.column.actualWidth
    },

    disabled() {
      return this.params.context.disableFilter
    },

    appliedFilters() {
      let appliedFilters = this.params.api.getFilterModel()[this.params.column.colDef.field]
      appliedFilters = appliedFilters && appliedFilters.filter ? appliedFilters.filter.split('_').length : null

      return this.params.column.filterActive ? appliedFilters : null
    }
  },

  methods: {
    //
    showMenu(e) {
      this.disabled || this.params.showColumnMenu(e.target)
      this.params.context.shownPopover = true
    },

    sortColumn() {
      this.params.progressSort()
    },

    pinColumn() {
      this.params.columnApi.setColumnPinned(this.params.column.colId, this.params.column.pinned ? null : 'left')
    },

    tooltip(sortState) {
      let tooltip = 'Sort'

      switch (sortState) {
        case SORT_ASCENDING: tooltip = 'Sort descending'; break
        case SORT_DESCENDING: tooltip = 'Sort ascending'; break
        case SORT_UNSORTED: tooltip = 'Sort ascending'
      }

      return tooltip
    }
  }
})

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.ag-fresh.editable {
  .ag-custom-header {
    padding-left: 5px;
  }
}

.grid.ag-fresh .ag-floating-bottom {
  .ag-cell.amount {
    padding: 0;
    margin-left: -7px;
  }
}

.ag-cell {
  &[col-id="0"] {
    // WARN: checkboxes column contains ellipsis due to
    // https://support.google.com/chrome/thread/14179981?hl=en
    // overriding default styles
    overflow: visible;
  }
}

.ag-header-cell {
  &:hover,
  .grid.layout-page .ag-fresh:not(.no-select-all) .ag-pinned-left-header &:not([col-id="action-expand"]) {
    @include theme {
    background: v(background-light);
    }
  }

  &[col-id="0"], &[col-id*="action"], &[col-id="details"] {
    &, &:hover {
      background: none;
    }
  }

  .badge {
    font-weight: 400;
    margin: 0 0 0 5px;
  }
}

.ag-fresh .ag-body .ag-row,
.ag-fresh .ag-body .ag-pinned-left-cols-viewport .ag-row {
  &-hover,
  &:hover {
    cursor: pointer;
    @include theme {
    box-shadow: 0px 0px 3px v(background);
    border-bottom: 1px solid v(background);
    }
  }
  &:hover {
    &:not(.expanded) {
      z-index: 99;
    }
  }
}

.ag-custom-header {
  white-space: normal;
  display: block;

  &.amount {
    text-align: right;
    padding-right: calc(7% + 2px);
  }

  .header-label {
    display: inline-block;
    margin-top: 2px;
    padding-left: 7px;
    @include theme {
    color: v(ink);
    }

    max-width: 95%;
    // WARN: re-enabling full-width due to
    // https://support.google.com/chrome/thread/14179981?hl=en
    // (WEBAPP-128)
    width: 90%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    vertical-align: middle;
    min-height: 18px;

    &.nowrap {
      white-space: normal;
      margin-top: -0.25em;
      line-height: 1;
      max-height: 2em;
    }

    &.disabled {
      cursor: default;
    }
  }

  [col-id="details"] & .header-label {
    padding: 0;
    width: 0;
  }
}

.ag-header-sort-icon {
  &:before {
    display: none;
  }
  @include theme {
  color: darken(v(background), 10%);
  }
  font-size: $font-size-base-xs;
  margin-left: 4px;
  cursor: pointer;
  vertical-align: top;
  text-align: center;

  .fa-caret {
    &-up {
      position: relative;
      top: 1px;
    }
    &-down {
      position: relative;
      top: -2px;
    }
    &-up.asc,
    &-down.desc {
      @include theme { color: v(ink) }
    }
  }
}

i.fas.ag-pin-column-icon {
  @include theme {
  color: v(background);
  }
  margin-left: 7px;
  margin-right: 5px;
  line-height: 1.3rem;
  // transform: rotate(-45deg);
  cursor: pointer;

  &.last {
    margin-right: 30px;
  }

  &.active {
    @include theme {
    color: v(attention-01);
    }
  }
}

.ag-fresh {
  &, &.ag-pinned-left-cols-viewport {
    .ag-row {
      @include theme {
      background: v(canvas);
      border-bottom: 1px solid v(background-light);
      }
      &.ag-row-selected {
        @include theme {
        //background: v(secondary-04);
        background: #DBE9F9;
        }
      }
      &.editing {
        @include theme {
        background-color: v(attention-03);
        }
      }
      &.invalid {
        @include theme {
        background-color: v(urgent-01);
        }
      }
    }
  }
  .ag-floating-bottom {
    .ag-row {
      background: inherit;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/header.vue